import { sdk } from 'src/utilities/sdk';

export enum SubtotalInvoiceMethod {
  DEPARTMENT = 'DEPARTMENT',
  LOCATION = 'LOCATION',
  MEAL_TYPE = 'MEAL_TYPE',
}

export interface IInvoiceContact {
  owner_id: string;
  invoice_contact_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  street1: string | null;
  street2: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  zip_code: string | null;
  primary: boolean;
}

export type InvoiceContactPayload = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
};

export interface InvoiceContactAPIProps {
  corpId: string;
  subtotalMethod: SubtotalInvoiceMethod;
  payload?: InvoiceContactPayload;
  invoiceContactId?: string;
  resourceId?: string;
  httpMethod?: 'get' | 'post' | 'put' | 'delete';
}

export async function addInvoiceContact({
  corpId,
  subtotalMethod,
  payload,
  resourceId,
}: InvoiceContactAPIProps): Promise<IInvoiceContact> {
  const endpointUrl = getInvoiceContactUrl({
    corpId,
    subtotalMethod,
    resourceId,
  });
  return sdk.http.post(endpointUrl, payload);
}

export async function getInvoiceContacts({
  corpId,
  subtotalMethod,
  resourceId,
}: InvoiceContactAPIProps): Promise<IInvoiceContact[]> {
  const endpointUrl = getInvoiceContactUrl({
    corpId,
    subtotalMethod,
    resourceId,
  });
  return sdk.http.get(endpointUrl);
}

export async function updateInvoiceContact({
  corpId,
  subtotalMethod,
  payload,
  invoiceContactId,
  resourceId,
}: InvoiceContactAPIProps): Promise<IInvoiceContact> {
  const endpointUrl = getInvoiceContactUrl({
    corpId,
    subtotalMethod,
    resourceId,
    invoiceContactId,
    httpMethod: 'put',
  });
  return sdk.http.put(endpointUrl, payload);
}

export async function deleteInvoiceContact({
  corpId,
  subtotalMethod,
  invoiceContactId,
  resourceId,
}: InvoiceContactAPIProps): Promise<IInvoiceContact> {
  const endpointUrl = getInvoiceContactUrl({
    corpId,
    subtotalMethod,
    resourceId,
    invoiceContactId,
  });
  return sdk.http.delete(endpointUrl);
}

export function getInvoiceContactUrl({
  corpId,
  subtotalMethod,
  invoiceContactId,
  resourceId,
  httpMethod,
}: InvoiceContactAPIProps): string {
  switch (subtotalMethod) {
    case SubtotalInvoiceMethod.DEPARTMENT: {
      return `/corps/${corpId}/invoice_contact${
        invoiceContactId ? `/${invoiceContactId}` : ''
      }/departments/${resourceId}`;
    }
    case SubtotalInvoiceMethod.LOCATION: {
      return `/corps/${corpId}/invoice_contact/locations/${resourceId}${
        invoiceContactId ? `/${invoiceContactId}` : ''
      }`;
    }
    case SubtotalInvoiceMethod.MEAL_TYPE:
    default:
      return `/corps/${corpId}/${
        httpMethod === 'put' ? 'invoice_contacts' : 'single_invoice_contacts'
      }${invoiceContactId ? `/${invoiceContactId}` : ''}`;
  }
}
